<template>
	<el-container>
		<el-scrollbar>
			<el-header class="header-top" style="height: 50px;"><s-header-top></s-header-top></el-header>
			<el-header class="header"><s-header></s-header></el-header>
			<el-main>
				<el-image style="width: 100%; height: 315px;background-color: #FFFFFF;" :src="require('../../static/us_bg.png')" fit="cover"></el-image>
				<div style="width: 100%; height: 60px;background-color: #FFFFFF;">
					<div class="content">
						<el-menu :default-active="activeIndex" active-text-color="#409EFF" class="el-menu-demo" mode="horizontal" @select="handleSelect">
							<el-menu-item index="1">平台简介</el-menu-item>
							<el-menu-item index="2">核心优势</el-menu-item>
							<el-menu-item index="3">荣誉资质</el-menu-item>
							<el-menu-item index="5">领军人才基地</el-menu-item>
							<el-menu-item index="4">入驻申请</el-menu-item>
						</el-menu>
					</div>
				</div>
				<div class="content">
					<!-- 平台简介 -->
					<el-row v-if="activeIndex == 1" class="page" style="background-color:inherit;">
						<brief-introduction></brief-introduction>
					</el-row>
					<!-- 核心优势 -->
					<el-row v-else-if="activeIndex == 2" class="page">
						<advantage></advantage>
					</el-row>
					<!-- 荣誉资质 -->
					<el-row v-else-if="activeIndex == 3" class="page">
						<honour></honour>
					</el-row>
					<!-- 领军人才基地 -->
					<el-row v-else-if="activeIndex == 5" class="page" style="background-color:inherit;">
						<training-base></training-base>
					</el-row>
					<!-- 入驻申请 -->
					<el-row v-else-if="activeIndex == 4" class="page">
						<apply-entry></apply-entry>
					</el-row>
				</div>
			</el-main>
			<el-footer class="footer"><s-footer></s-footer></el-footer>
			<el-footer class="copy-right"><s-copyRight></s-copyRight></el-footer>
		</el-scrollbar>
	</el-container>
</template>

<script>
import sHeaderTop from '@/components/header_top'
import sHeader from '@/components/header';
import sFooter from '@/components/footer';
import sCopyRight from '@/components/copy-right';
import honour from '@/components/honour';//荣誉资质
import advantage from '@/components/advantage';//核心优势
import briefIntroduction from '@/components/brief-introduction';//平台简介
import trainingBase from '@/components/training-base';//平台简介
import applyEntry from '@/components/apply-entry';//入驻申请
import { dictList } from '@/api';

export default {
	name: 'aboutUs',
	components: {
		sHeaderTop,
		sHeader,
		advantage,//核心优势
		briefIntroduction,//平台简介
		applyEntry,//入驻申请
		trainingBase,//领军人才基地
		honour,//荣誉资质
		sFooter,
		sCopyRight
	},
	data() {
		return {
			activeIndex: '1', //tab切换
		};
	},
	mounted() {
	},
	methods: {
		//切换菜单
		handleSelect(key) {
			this.activeIndex = key;	
		},
	}
};
</script>

<style lang="scss" scoped>
.el-main{
	padding: 0px 0px 20px 0px;
}
.page {
	min-height: 524px; /*若没有tabs56  height524 若有height468 */
}

.el-menu.el-menu--horizontal {
	border-bottom: none;
}

</style>



// WEBPACK FOOTER //
// src/views/about-us.vue